import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import Clock from '../../assets/img/clock.png'
import { EMPTY_ARRAY, EMPTY_OBJECT, EVENT_TYPES } from '../../constants/globalConstants'
import URL from '../../constants/urls'
import noop from 'lodash/noop'
import { formatAMPM, formatDate, formatDateDays, getEventLogName, isNetworkAvailable } from '../../utils/helper'
import { storeEventLog } from '../../redux/actions/eventLogActions'
import { connect } from 'react-redux'
import getConfigDetails from '../../services/config'
import { getImage } from '../../utils/helper'
import { PassEventAnalytics } from '../../utils/GoogleAnalytics'
import useNetwork from '../../hooks/NetworkDetector'
import {bookingAllowTime,bookingMsg} from '../../utils/helperTimeZone'
import { Tooltip} from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

function Pass(props) {
	const { eventData, event_type, passCard, dispatch, loader, soldOut } = props
	const [isLoading, setIsLoading] = useState(false)
	const [chooseEvents, setchooseEvents] = useState([])
	const [numerSelectedEvents, setnumerSelectedEvents] = useState(0)
	const [pass_total_usage, setpass_total_usage] = useState()
	const [event_disabled, setevent_disabled] = useState(false)
	// const [event_checked,setevent_checked] = useState(false)
	const [message, setMessage] = useState()
	const isOnline = useNetwork()

	useEffect(() => {
		setIsLoading(loader)
	}, [EMPTY_ARRAY, loader])
	const navigate = useNavigate()

	const handleBookParking = () => {
		if (isOnline) {
			if (isNetworkAvailable()) {
				if (soldOut == 0) {
					(eventData?.pass_type_slug == EVENT_TYPES?.BUNDLE_PASS && eventData?.is_full_season != 1) ? eventData.SelectedEvents = localStorage.getItem('userChooseEvents') : null
					const payload = {
						'error_message': JSON.stringify(eventData),
						'facility_id': getConfigDetails.FACILITY_ID,
						'event_name': getEventLogName(eventData?.pass_type_slug, eventData?.is_full_season),
						'user_id': 0,
						'user_ip': localStorage.getItem('user_ip')
					}
					dispatch(storeEventLog(payload))
					localStorage.setItem(EVENT_TYPES?.EVENT, JSON.stringify(eventData))
					const PassEventAnalyticsPayloads = {
						event_type: event_type,
						facility_id: getConfigDetails.FACILITY_ID,
						card_data: eventData
					}
					ClickPassEventAnalytics(PassEventAnalyticsPayloads)
					navigate(URL.PAYMENT)
				}
			} else {
				// setErrorMessage('Please check the Internet Connection!')
			}
		}
	}

	const ClickPassEventAnalytics = (data) => {
		PassEventAnalytics(data)

	}

	const handleCheckBoxEvent = (e) => {
		setevent_disabled(false)
		// setevent_checked(true)
		const SelectedEvents = chooseEvents //Array in parent component
		const value = e.target.value //Checkbox value
		var index = SelectedEvents?.indexOf(e.target.value)
		SelectedEvents?.includes(value) //If Array contains value		
			//? SelectedEvents.filter((tool) => tool.value != value) // Then remove item from Array
			? (SelectedEvents?.indexOf(value) !== -1 && !e.target.checked) ? SelectedEvents?.splice(index, 1) : ''
			: SelectedEvents?.push(value) // Else, push item to Array;
		if (event_type == EVENT_TYPES?.BUNDLE_PASS && passCard.is_full_season == 0) {
			if (SelectedEvents?.length < pass_total_usage) {
				setMessage()
			} else {
				setMessage('Allow Only ' + pass_total_usage + ' Event')
				setevent_disabled(true)
			}
		}

		setchooseEvents(SelectedEvents)
		setnumerSelectedEvents(SelectedEvents?.length)
		localStorage.setItem('userChooseEvents', SelectedEvents)

	}

	const home = eventData?.all_event
	useEffect(() => {
		setpass_total_usage(passCard?.total_usage)
	})

	return (
		(eventData && eventData?.all_event && Array.isArray(eventData?.all_event) && eventData?.all_event?.length > 0) ? (isLoading ? null : <div>
			<div className="accordion" id={'accordionExample'}>
				<div className="accordion-item   mb-3 text-white ">
					<div className="accordion-header bg-primary p-2" id={'headingOne'}>
						<div
							className="row g-0  align-items-center "

						>
							<div className="col-sm col-sm p-2">
								<h4 className="m-0">{passCard?.description}</h4>

								{(event_type == EVENT_TYPES?.BUNDLE_PASS && passCard?.is_full_season == 0)
									&& <small className='m-0 d-block d-sm-none'><b>{numerSelectedEvents}</b> of <b>{pass_total_usage}</b> games are selected</small>
								}

							</div>
							<div className="col-sm col-12 text-center d-none"><span>{message}</span></div>
							{(event_type == EVENT_TYPES?.BUNDLE_PASS && passCard?.is_full_season == 0)
								&& <div className='col text-center d-none d-sm-block p-2'>
									<h4>{numerSelectedEvents} of {pass_total_usage} games are selected</h4>
								</div>
							}

							<div className=" col text-end ">
								<span className='fw-bold'>$ {passCard?.price}</span>
								&nbsp;&nbsp;
								{(event_type == EVENT_TYPES?.BUNDLE_PASS && passCard?.is_full_season == 0) ? <button disabled={(numerSelectedEvents == 0 || soldOut == 1) ? true : false} onClick={(e) => handleBookParking(e, chooseEvents)} className="btn btn-danger text-white">
									Book Now
								</button> : <button disabled={soldOut == 1 ? true : false} onClick={(e) => handleBookParking(e, chooseEvents)} className="btn btn-danger text-white">
									Book Now
								</button>}
							</div>
						</div>
					</div>
					<div
						id={'collapseOne'}
						className={'accordion-collapse collapse show'}


					>
						<div className="accordion-body p-0">
							<div className="table-responsive tableFixHead">
								<table className="table tableTime">
									<thead className='row g-0'>
										<th className='col'>Date</th>
										<th className='col'>Game Start</th>
										<th className='col'>Playing Against</th>
										{/* <th>Rate</th> */}
										{(event_type == EVENT_TYPES?.BUNDLE_PASS && passCard?.is_full_season == 0) ? <th className='col'  >Select Game</th> : null}
									</thead>
									<tbody>
										{home?.map((val, idx) => {

											return (
												<tr className='row g-0' key={idx}>
													<td className='col'>
														<b>{formatDate(val?.start_time)}</b>


														, <small>{formatDateDays(val?.start_time)}</small>
													</td>
													<td className='col'>
														<img src={Clock} width="15px" alt="Clock" /> &nbsp;
														{formatAMPM(val?.start_time)}{' '}
														{val?.parking_time_message ? <small className='d-block lh-sm'>{val?.parking_time_message}</small> : null}
													</td>
													<td className='col'>
														<div className='d-flex align-items-center'>
															<div>
																<img width="50px" src={getImage(val)} alt="" />

															</div>
															<div style={{ lineHeight: '20px', marginLeft: '10px' }}> {val?.slug}</div>
														</div>
														{/* {/ <img src={Compti} width="45px" alt="Compti" /> /} */}

													</td>
													{/* <td className='col'>
													<img
														width="50px"
														
														src={
															process.env.PUBLIC_URL +
															'/game-icons/' +val?.slug?.replace(/ /g, '')+
															'.png'
														}
														alt=""
													/> */}
													{/* <img src={Compti} width="45px" alt="Compti" /> */}
													{/* &nbsp;  &nbsp;{val?.slug}
												</td> */}
													{/* <td>${val.event_rate}</td> */}

													{(event_type == EVENT_TYPES?.BUNDLE_PASS && passCard?.is_full_season == 0) ? <td className="col text-center selectBox" >

														<label className="b-contain mx-auto  mt-2" data-tooltip-place={'left-start'}  data-tooltip-id={bookingAllowTime(val) ? 'book-tooltip' : 'non-book-tooltip'} data-tooltip-content={bookingMsg}>
															<input type="checkbox"
																name={'chooseEvent_' + val?.id}
																value={val?.id}
																id={'chooseEvent_' + val?.id}
																//checked={chooseEvents.find((ch) => ch == val.id)?event_checked:false}															
																disabled={chooseEvents?.find((ch) => ch == val?.id) ? false : event_disabled}
																onClick={(e) => handleCheckBoxEvent(e, idx)}
															/>
															<div className="b-input"></div>
														</label>


													</td> : null}
												</tr>
											)
										})}
									</tbody>
								</table>
								<Tooltip id="book-tooltip" className="maxWidth200"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>) :
			(<div className='text-center w-50 mx-auto text-danger card bg-danger border-danger bg-opacity-10 card-body'><h3 className='m-0'>Event Not Found!!</h3>
			</div>)
	)
}
Pass.propTypes = {
	eventData: PropTypes.object,
	event_type: PropTypes.string,
	passCard: PropTypes.object,
	event_id: PropTypes.number,
	dispatch: PropTypes.func,
	loader: PropTypes.bool,
	soldOut: PropTypes.string
}

Pass.defaulProps = {
	eventData: EMPTY_OBJECT,
	event_id: PropTypes.number,
	dispatch: noop,
	loader: false,
	soldOut: undefined

}
function mapStateToProps({ eventLogReducer, eventDetailsReducer }) {
	return {
		data: eventLogReducer,
		loader: eventDetailsReducer.loader
	}
}
export default connect(mapStateToProps)(Pass)
